import React from 'react';

import DriverETAMap from './DriverETAMap';

import style from './driverETA.module.css';

import Moment from 'moment';

import Button from '@material-ui/core/Button';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import googleMapIcon from '../../../assets/googleMapIcon.jpeg';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      textTransform: 'none',
      padding: '10px 35px',
      marginTop: '20px'
    }
  });

interface driverETASelectAutoProps {
  classes: any;
  poNumber: string;
  fdTextLogo: string;
  arrivalTime: Date;
  arrivesIn: string;
  setETAAuto: boolean;
  destination: { lat: number, lng: number } | null;
  userLocation: { lat: number, lng: number } | null;
  setETA: () => void;
};

const driverETASelectAuto = (props: driverETASelectAutoProps) => {
  const { poNumber, fdTextLogo, arrivalTime, arrivesIn, destination, userLocation, setETAAuto, classes } = props;
  
  return (
    <div className={ style.fullWidth }>
      <div className={ `${style.flexRow} ${style.driverETAHeader}` }>
        <div className={ style.flexRow }>
          <img className={ style.logoImg } src={ fdTextLogo } alt="frontline dynamics logo" />
          <span className={ style.poNumber }><strong>{ poNumber }</strong></span>
        </div>
        <span className={ style.pageHeaderSpan }>Select ETA</span>
      </div>
      <div className={ style.timesDiv }>
        <img src={ googleMapIcon } className={ style.mapIcon } />
        <div className={ style.wrapperContent }>
          <div className={ style.content }>
            <span className={ style.text }>Current Date &#38; Time:</span> 
          </div>
          <div className={ style.content }>
            <span className={ style.text }>Estimated Time Arrival:</span>
            { setETAAuto ?
            <span className={ style.moment }>{ Moment(arrivalTime).format('DD MMM YYYY HH:MM').toUpperCase() }</span> :
            <span className={ style.moment }>------------</span>
            }
            </div>
        </div>
      </div>
      <div className={ style.mapTable }>
        <div className={ style.alignRight }>
          Arrives in: { arrivesIn }
        </div>
        <div className={ style.mapContainer }>
          {userLocation !== null?<DriverETAMap destination={ destination || { lat: 0, lng: 0 } } userLocation={ userLocation } />:null }
        </div>
      </div>
      <div className={ style.buttonETADiv }>
        { setETAAuto ? 
        <div>
          ETA { Moment(arrivalTime).format('HH:MM') }
        </div> :
        <div> ETA ----- </div>
        }
        <Button
          variant="contained"
          onClick={ props.setETA }
          color={ 'primary' }
          className={ classes.button } 
          disabled={ !props.setETAAuto }
        >
          Set ETA (auto) 
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(driverETASelectAuto);